var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.finalClass},[(_vm.spinToggle)?_c('span',{class:`spinner-border spinner-border-sm ${!_vm.emptySlot ? 'mr-3' : ''}`}):_vm._e(),(!_vm.emptySlot)?_vm._t("default",function(){return [_vm._v("Loading...")]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }